import './request-info.scss';
import {useIntl} from "react-intl";
import {Field, useFormikContext} from 'formik';
import {typeIdentification} from '../../../__mocks__/data';
import _ from 'lodash';
import {WLOCreditAPIService} from '../../../services';
import toast from "react-hot-toast";
import {useLoginContext} from '../../../hooks/useLoginContext';
import {useRequestContext} from '../../../hooks/useRequestContext';
import {ANIPersona, CygnusPersona} from '../../../context/RequestContext';
import {useEffect, useState} from 'react';
import BarLoader from "react-spinners/BarLoader";
import ClockLoader from "react-spinners/ClockLoader";

interface FormKnowYouProps {
    errors?: any,
    values?: any,
}
export function FormKnowYou(props: FormKnowYouProps) {
    const {user} = useLoginContext();
    const {request, setRequest} = useRequestContext();
    const [isLoadingInfo, setIsLoadingInfo] = useState(false);
    const {errors, values} = props;
    const {setFieldValue} = useFormikContext();
    const intl = useIntl();
    const isVendedor = user?.idProfile === '4';

    const tiposIdentificacion =
        typeIdentification?.WS_TIPOS_IDENTIFICACION_IResult?.LstTiposIdent?.Datos_TiposIdentificacion ?? [];
    const tiposIdentificacionOrdenados = [...tiposIdentificacion].sort((a: any, b: any) => {
        const aIsCedula = String(a?.s_codigo) === '13';
        const bIsCedula = String(b?.s_codigo) === '13';
        if (aIsCedula === bIsCedula) return 0;
        return aIsCedula ? -1 : 1;
    });
    
    const handleSearch = async (numDoc?: string, numTipoDoc?: string) => {
        console.log("Inicia busqueda de persona")
        let consultaANI = false;
        setIsLoadingInfo(true);
        // Usar los valores pasados como parámetros o los del formulario
        const docToSearch = numDoc || values.Pws_Identificacion;
        const tipoDocToSearch = numTipoDoc || values.Pws_Tip_Identificacion;
        
        // if (datosPersona){
                    if(docToSearch && !isNaN(docToSearch as any)){
                        try {
                            const person = await WLOCreditAPIService.consultaSolicitudCygnus({
                                Pws_Tip_Identificacion: tipoDocToSearch!,
                                Pws_Identificacion: docToSearch!
                            });
                            if (!_.isEmpty(person.payload)) {

                                if (person.payload.result === "1") {
                                    console.log("person.payload.result === 1")
                                    const pCygnus = person.payload?.data?.datos_persona?.Datos_persona[0] as CygnusPersona;
                                    setFieldValue('Pws_Apellidos1', pCygnus.Pws_Apellidos1);
                                    setFieldValue('Pws_Apellidos2', pCygnus.Pws_Apellidos2);
                                    setFieldValue('Pws_Nombres', pCygnus.Pws_Nombres);
                                    setRequest({...request, personCygnus: pCygnus, errorConsulta: false});
                                    localStorage.setItem('person', JSON.stringify(person.payload.data.datos_persona.Datos_persona[0]));
                                    setIsLoadingInfo(false);

                                    console.log("Entre a buscar en cygnus")
                                    } else {
                                        console.log("person.payload.result != 1")
                                        console.log(person.payload)
                                    consultaANI = true;
                                    // const personANI = await WLOCreditAPIService.consultaSolicitudANI({
                                    //     Pws_Tip_Identificacion: values.Pws_Tip_Identificacion!,
                                    //     Pws_Identificacion: values.Pws_Identificacion!,
                                    //     Pws_fecha_expedicion: localStorage.getItem('fechaExp') || ''
                                    // });
                                    
                                    // const pANI = personANI as ANIPersona;
                                    // const fecha = personANI.fechaExpedicion.split('/');
                                    // values.Pws_Apellidos1=pANI.primerApellido;
                                    // values.Pws_Apellidos2=pANI.segundoApellido;
                                    // values.Pws_Nombres=pANI.primerNombre+" "+pANI.segundoNombre;
                                    // values.Pws_Fec_expe= fecha[2]+'-'+fecha[1]+'-'+fecha[0]
                                    // pANI.fechaExpedicion = fecha[2]+'-'+fecha[1]+'-'+fecha[0]
                                    setRequest({...request, searchANI: true, errorConsulta: false});
                                    console.log("request en formknowyou", {...request, searchANI: true, errorConsulta: false})
                                    localStorage.setItem('person', JSON.stringify(person));
                                    setIsLoadingInfo(false);
                                }
                            }else{
                                toast.error('En estos momentos no podemos atender su solicitudxx',{
                                    duration:5000,
                                });
                                console.log("person en formknowyou", person)
                              
                            }
                        } catch (e) {
                            const error = e as any;
                            if (!_.isEmpty(error?.response?.data)) {
                                setRequest({...request, errorConsulta: true});
                                const menssage = error.response.data as any;
                                toast.error("El documento de identificación no existe.",{
                                    duration:5000,
                                });
                                setTimeout(() => {
                                    setIsLoadingInfo(false);
                                }, 5000);
                        } else {
                            setRequest({...request, errorConsulta: true});
                            toast.error('En estos momentos no podemos atender su solicitud',{
                                duration:5000,
                            });
                            setTimeout(() => {
                                setIsLoadingInfo(false);
                            }, 5000);
                            
                        }
                        }
                    }else{
                        setIsLoadingInfo(false);
                        toast.error("El documento de identificacion debe ser numerico",{
                            duration:5000,
                        })
                    }
        // }
    }

    useEffect(() => {

        //if (isVendedor) return;
        const datosPersonaString = localStorage.getItem("personaValidada");
        if (datosPersonaString) {
          
            const datosPersona = JSON.parse(datosPersonaString);
            const numDoc = datosPersona.numIdenVal;
            const numTipoDoc = datosPersona.tipIdenVal;
            const fechaExp = datosPersona.fechaExp;
            if (numDoc) {
                setFieldValue('Pws_Identificacion', numDoc);
            }
            if (numTipoDoc) {
                setFieldValue('Pws_Tip_Identificacion', numTipoDoc);
            }
            if (fechaExp) {
                setFieldValue('Pws_Fec_expe', fechaExp);
            }

            // Llamar handleSearch con los valores del localStorage
            if (numDoc && numTipoDoc) {
                handleSearch(numDoc, numTipoDoc);
            }
        } else {

            // Si no hay datos en localStorage, fijar CÉDULA como tipo por defecto
            setFieldValue('Pws_Tip_Identificacion', '13');
          
            // Si hay datos en el formulario, intentar buscar
            if (values.Pws_Identificacion && values.Pws_Tip_Identificacion) {
                handleSearch();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isVendedor]);

    return (
        <div className={'row'}>
            <ClockLoader id='spinner' color={"#4FAE32"} loading={isLoadingInfo} size={100}/>
            <div className={"title-medium-red"}>{intl.formatMessage({id: "form_credit_information_title"})}</div>
            <div className={"subtitle-medium"}>{intl.formatMessage({id: "form_credit_information_subtitle"})}</div>
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-right flex-grow-6"}>
                    <Field as="select"
                        id={"Pws_Tip_Identificacion"}
                        name={"Pws_Tip_Identificacion"}
                        className={`${errors.Pws_Tip_Identificacion ? 'form-know-you-item-input-small input-error' : 'form-know-you-item-input-small'}`}
                        disabled={!isVendedor}>
                        {typeIdentification && typeIdentification.WS_TIPOS_IDENTIFICACION_IResult.LstTiposIdent.Datos_TiposIdentificacion.map((item, key: number) => {
                            return (
                                <option key={key} value={item.s_codigo}>{item.s_descripcion}</option>
                            )
                        })}
                    </Field>
                </div>
                <div className={"flex-container-form-know-you-item-left flex-grow-6"}>
                    <Field id={"Pws_Identificacion"}
                        name={"Pws_Identificacion"}
                        disabled={!isVendedor}
                        onBlur={() => {
                            if (isVendedor && values.Pws_Identificacion?.trim() && values.Pws_Tip_Identificacion) {
                                handleSearch();
                            }
                        }}
                        className={`${errors.Pws_Identificacion ? 'form-know-you-item-input-small input-error' : 'form-know-you-item-input-small'}`}/>
                </div>
            </div>
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-center flex-grow-6"}>
                    <Field id={"Pws_Nombres"}
                        name={"Pws_Nombres"}
                        className={`${errors.Pws_Nombres ? 'form-know-you-item-input-large input-error' : 'form-know-you-item-input-large'}`}
                        placeholder={"Nombres"}/>
                </div>
            </div>
                <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-right flex-grow-6"}>
                    <Field id={"Pws_Apellidos1"}
                        name={"Pws_Apellidos1"}
                        className={`${errors.Pws_Apellidos1 ? 'form-know-you-item-input-small input-error' : 'form-know-you-item-input-small'}`}
                        placeholder={'Primer Apellido'}/>
                </div>
                <div className={"flex-container-form-know-you-item-left flex-grow-6"}>
                    <Field id={"Pws_Apellidos2"}
                        name={"Pws_Apellidos2"}
                        className={`${errors.Pws_Apellidos2 ? 'form-know-you-item-input-small input-error' : 'form-know-you-item-input-small'}`}
                        placeholder={'Segundo Apellido'}/>
                </div>
                </div>
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-right flex-grow-6"}>
                    <Field id={"Pws_Telefono1"}
                        name={"Pws_Telefono1"}
                        className={`${errors.Pws_Telefono1 ? 'form-know-you-item-input-small input-error' : 'form-know-you-item-input-small'}`}
                        placeholder={intl.formatMessage({id: "placeholder_phone_1"})}/>
                </div>
                <div className={"flex-container-form-know-you-item-left flex-grow-6"}>
                    <Field id={"Pws_Correo"}
                        name={"Pws_Correo"}
                        className={`${errors.Pws_Correo ? 'form-know-you-item-input-small input-error' : 'form-know-you-item-input-small'}`}
                        placeholder={intl.formatMessage({id: "placeholder_mail"})}/>
                </div>
            </div>
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-right flex-grow-6"}>
                    <Field id={"Pws_Telefono2"}
                        name={"Pws_Telefono2"}
                        className={`${errors.Pws_Telefono2 ? 'form-know-you-item-input-small input-error' : 'form-know-you-item-input-small'}`}
                        placeholder={intl.formatMessage({id: "placeholder_phone_2"})}/>
                </div>
                <div className={"flex-container-form-know-you-item-left flex-grow-6"}>
                    <Field id={"mail_confirmation"}
                    onPaste={(e:any)=>{
                        e.preventDefault()
                        return false;
                    }} 
                    autoComplete="off"
                    name={"mail_confirmation"}
                    className={`${errors.mail_confirmation ? 'form-know-you-item-input-small input-error' : 'form-know-you-item-input-small'}`}
                    placeholder={intl.formatMessage({id: "placeholder_mail_confirmation"})}/>
                </div>
            </div>
        </div>

    )
}